import React, { createContext, useContext, useState } from 'react';

const EmployeeContext = createContext();

export const useEmployee = () => useContext(EmployeeContext);

export const EmployeeProvider = ({ children }) => {
    const [employee, setEmployee] = useState(null);

    return (
        <EmployeeContext.Provider value={{ employee, setEmployee }}>
            {children}
        </EmployeeContext.Provider>
    );
};
